import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TabContextService } from '../tab-context.service';

@Injectable()
export class ConsolidatorIdInterceptor implements HttpInterceptor {
  constructor(private tabCtx: TabContextService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // CAT-4162: temporarily disabled. The x-selected-consolidator-id header
    // behaved inconsistently across users of the same agency (empty for some,
    // set for others) because its value depends on the isChild flag and on the
    // getConsolidators response persisted in sessionStorage. Kept as a
    // passthrough until the consolidator selection logic is reviewed.
    return next.handle(request);

    // Skip auth endpoints (igual que delegatorAgencyInterceptor)
    // if (request.url.includes('/auth')) {
    //   return next.handle(request);
    // }
    //
    // const selectedConsolidatorId = this.tabCtx.getConsolidatorId();
    //
    // const clonedRequest = request.clone({
    //   setHeaders: {
    //     'x-selected-consolidator-id': selectedConsolidatorId,
    //   },
    // });
    //
    // return next.handle(clonedRequest);
  }
}
